import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Employee } from "src/app/models/employee.model";
import { ApiService } from "../api.service";
import { BaseService } from "./base.service";

@Injectable({
    providedIn: 'root'
  })
  export class LoginService extends BaseService {

    constructor (
      protected apiService: ApiService,
      protected http: HttpClient
    ) {
      super(apiService, http, '');
    }

  updatePassword(password: string) {
    return this.http.put<any>(`${this.apiUrl}employees/[employee-id]/login/password`, JSON.stringify(password), {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })});
  }
}
